import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: '#1A1A1A',
      padding: '64px 0',
      [theme.fn.largerThan('sm')]: {
        padding: '100px 0',
      },
    },
    inner: {
      display: 'flex',
      flexDirection: 'column',
      gap: 36,
      [theme.fn.largerThan('sm')]: {
        gap: 80,
      },
    },
    thumbnail: {
      height: 200,
    },
    descWrapper: {
      position: 'relative',
    },
    desc: {
      color: '#595959',
      fontSize: 22,
      lineHeight: rem(33),
      [theme.fn.largerThan('sm')]: {
        fontSize: 32,
        lineHeight: rem(42),
      },
    },
    descOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      backgroundClip: 'text',
      backgroundImage:
        'linear-gradient(175.61deg, #2D87F3 1.1%, #26E187 61.79%, #CAEDFE 105.65%)',
      '-webkit-text-fill-color': 'transparent',
      transition: 'all 2.5s ease',
      clipPath: 'circle(1% at 0 0)',
      '&.fill-bg': {
        clipPath: 'circle(150% at 0 0)',
        backgroundImage:
          'linear-gradient(175.61deg, #2D87F3 1.1%, #26E187 61.79%, #CAEDFE 105.65%)',
      },
      [theme.fn.largerThan('sm')]: {
        backgroundImage:
          'linear-gradient(85.58deg, #2D87F3 6.64%, #26E187 38.45%, #CAEDFE 87.17%)',
        '&.fill-bg': {
          backgroundImage:
            'linear-gradient(85.58deg, #2D87F3 6.64%, #26E187 38.45%, #CAEDFE 87.17%)',
        },
      },
    },
    listing: {
      display: 'flex',
      flexDirection: 'column',
      gap: 48,
    },
    group: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 24,
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
    },
    heading: {
      fontSize: 20,
      lineHeight: rem(30),
      textAlign: 'right',
      position: 'relative',
      paddingBottom: 12,
      color: '#fff',
      backgroundImage: 'linear-gradient(90deg, #D9D9D9 0%, #737373 100%)',
      backgroundClip: 'text',
      '-webkit-text-fill-color': 'transparent',
      '&:after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        height: 1,
        backgroundImage:
          'linear-gradient(93.31deg, #2D87F3 0.41%, #26E187 30.84%, #CAEDFE 77.43%)',
      },
      [theme.fn.smallerThan('sm')]: {
        textAlign: 'center',
        fontSize: 18,
        lineHeight: rem(28),
      },
    },
  }
})
